import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { SplitText } from 'gsap/all';
import { Maths } from '../_app/cuchillo/utils/Maths';

const RANGES = { title: [0.2, 0.3], show: [0.3, 0.6], fill: [0.5, 0.75] };

class ScrollItem__StepItems extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._setupTitle(__link);
        this._setupUnits(__link);

        this.onMove = () => {
            const titleP = Maths.clamp(Maths.normalize(RANGES.title[1], RANGES.title[0], this.progressInside), 0, 1);
            this._drawTitle(titleP);

            const showOpacity = Maths.clamp(Maths.normalize(RANGES.show[1], RANGES.show[0], this.progressInside), 0, 1);
            const fillProgress = Maths.clamp(Maths.normalize(RANGES.fill[1], RANGES.fill[0], this.progressInside), 0, 1);
            this._draw(showOpacity, fillProgress);
        };
    }

    _setupTitle(__link) {
        this._titlLine = [];
        this._titleInc = 0;

        const titleEl = GetBy.class('label', __link)[0];
        if (!titleEl) return;

        this._titlLine = new SplitText(titleEl, {
            type: 'lines',
            linesClass: 'line-child'
        }).lines;

        this._titleInc = this._titlLine.length > 0 ? 1 / this._titlLine.length : 0;
        this._drawTitle(0);
    }

    _drawTitle(titleP) {
        let p0 = 0;
        let p1 = this._titleInc;

        for (let i = 0; i < this._titlLine.length; i++) {
            const vis = Maths.clamp(Maths.normalize(p1, p0, titleP), 0, 1);
            this._titlLine[i].style.transform = `translateY(${(1 - vis) * 100}%)`;
            p0 = p1;
            p1 += this._titleInc;
        }
    }

    _setupUnits(__link) {
        this._units = [...GetBy.selector('.items .item', __link)];

        this.totalItems = this._units.length;
        this.inc = this.totalItems > 0 ? 1 / this.totalItems : 0;

        this._draw(0);
    }

    _draw(showP, fillP) {
        let p0 = 0;
        let p1 = this.inc;

        for (let i = 0; i < this.totalItems; i++) {

            const opacity = Maths.clamp(Maths.normalize(p1, p0, showP), 0, 1);
            const progress = Maths.clamp(Maths.normalize(p1, p0, fillP), 0, 1);

            const item = this._units[i];

            item.style.opacity = opacity;
            item.style.setProperty('--progress', progress);

            p0 = p1;
            p1 += this.inc;
        }
    }
}

Scroll._registerClass('StepItems', ScrollItem__StepItems);

export default ScrollItem__StepItems;
